import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const TILES = [
  { cat: "tshirts", title: "T-shirts", note: "Heavyweight cotton, boxy cuts", img: "/img/tee-shades.jpg", span: "md:col-span-7", h: "h-[440px] md:h-[620px]" },
  { cat: "hoodies", title: "Hoodies", note: "450gsm, built warm", img: "/img/hood-black.jpg", span: "md:col-span-5", h: "h-[440px] md:h-[620px]" },
  { cat: "accessories", title: "Accessories", note: "Caps, beanies & totes", img: "/img/cap-tote.jpg", span: "md:col-span-12", h: "h-[380px] md:h-[460px]" },
];

const Tile = ({ t, i }) => (
  <Link
    to={`/shop?category=${t.cat}`}
    data-testid={`bento-tile-${t.cat}`}
    className={`group relative block overflow-hidden bg-ink ${t.h}`}
  >
    <img
      src={t.img}
      alt={t.title}
      loading="lazy"
      className="absolute inset-0 h-full w-full object-cover opacity-90 transition-[transform,opacity] duration-[1400ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-105 group-hover:opacity-70"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent" />
    <span className="absolute left-5 top-5 font-mono text-[11px] tracking-[0.25em] text-bone">{String(i + 1).padStart(2, "0")} / {String(TILES.length).padStart(2, "0")}</span>
    <div className="absolute inset-x-5 bottom-5 flex items-end justify-between text-bone">
      <div>
        <p className="font-display text-4xl leading-none md:text-5xl">{t.title}</p>
        <p className="mt-2 text-sm text-bone/85">{t.note}</p>
      </div>
      <span className="flex h-12 w-12 items-center justify-center rounded-full border border-bone/60 transition-[background-color,color,transform] duration-500 group-hover:rotate-45 group-hover:bg-bone group-hover:text-ink">
        <ArrowUpRight className="h-5 w-5" />
      </span>
    </div>
  </Link>
);

export const Bento = () => (
  <section data-testid="bento-section" className="mx-auto max-w-[1600px] px-5 pb-24 md:px-10 md:pb-36">
    <Reveal className="mb-12 grid gap-6 md:grid-cols-12">
      <h2 className="font-display text-5xl font-light leading-none md:col-span-7 md:text-7xl">The wardrobe, <em>in three rooms.</em></h2>
      <p className="self-end text-stone md:col-span-4 md:col-start-9">Every category is built around a single idea of proportion, so pieces move between rooms without friction.</p>
    </Reveal>
    <div className="grid grid-cols-1 gap-4 md:grid-cols-12">
      {TILES.map((t, i) => (
        <Reveal key={t.cat} delay={(i % 3) * 0.08} className={t.span}>
          <Tile t={t} i={i} />
        </Reveal>
      ))}
    </div>
  </section>
);
